import React from "react";
import { styles, MarjInput } from "./adminStyles";

/**
 * Ozan+Marj sekmesi marj input alanlari
 * Pure presentational - tum state ve handler'lar prop ile gelir.
 */
const OzanMarjInputs = ({
  isDesktop,
  priceSource,
  applyMarj,
  marjProducts,
  marj,
  editingMode,
  getModeName,
  handleChange,
  marjVal,
  toggleMarjProduct,
  toggleAllMarjProducts,
}) => {
  const sectionRow = isDesktop
    ? { ...styles.section, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }
    : styles.section;
  const sectionH3 = isDesktop
    ? { margin: 0, minWidth: '180px', fontSize: '16px', whiteSpace: 'nowrap', fontWeight: 'bold' }
    : {};

  const showCheckboxes = priceSource === 'altinkaynak' && applyMarj;
  const marjCheckbox = (productKey) => showCheckboxes ? (
    <input type="checkbox" checked={!!marjProducts[productKey]} onChange={() => toggleMarjProduct(productKey)}
      style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#DA9F54', marginLeft: 'auto', flexShrink: 0 }}
      data-testid={`marj-check-${productKey}`} />
  ) : null;

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{color: '#DA9F54', margin: 0, fontSize: '18px'}}>{getModeName(editingMode)} Marjlari Duzenle</h2>
        {showCheckboxes && (
          <button onClick={toggleAllMarjProducts} data-testid="select-all-marj-btn"
            style={{ padding: '6px 14px', fontSize: '12px', fontWeight: 'bold', borderRadius: '6px', cursor: 'pointer', border: '1px solid #DA9F54', backgroundColor: Object.values(marjProducts).every(v => v) ? '#DA9F54' : 'transparent', color: Object.values(marjProducts).every(v => v) ? '#000' : '#DA9F54' }}>
            {Object.values(marjProducts).every(v => v) ? 'Hepsini Kaldir' : 'Hepsini Sec'}
          </button>
        )}
      </div>
      <div style={sectionRow}><h3 style={sectionH3}>1 Gram</h3><MarjInput label="Alis" marjKey="gram_1_alis" value={marjVal('gram_1_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="gram_1_satis" value={marjVal('gram_1_satis')} onChange={handleChange} />{marjCheckbox('gram_1')}</div>
      <div style={sectionRow}><h3 style={sectionH3}>5-10-20 Gram Satis</h3><MarjInput label="Satis" marjKey="gram_5_10_20_satis" value={marjVal('gram_5_10_20_satis')} onChange={handleChange} />{marjCheckbox('gram_5_10_20')}{!isDesktop && <p style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>Alis: QEN 1 Gram Bozma x Gram (otomatik)</p>}</div>
      <div style={sectionRow}><h3 style={sectionH3}>Ceyrek</h3><MarjInput label="Alis" marjKey="ceyrek_alis" value={marjVal('ceyrek_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="ceyrek_satis" value={marjVal('ceyrek_satis')} onChange={handleChange} />{marjCheckbox('ceyrek')}</div>
      <div style={sectionRow}><h3 style={sectionH3}>Yarim</h3><MarjInput label="Alis" marjKey="yarim_alis" value={marjVal('yarim_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="yarim_satis" value={marjVal('yarim_satis')} onChange={handleChange} />{marjCheckbox('yarim')}</div>
      <div style={sectionRow}><h3 style={sectionH3}>Teklik</h3><MarjInput label="Alis" marjKey="teklik_alis" value={marjVal('teklik_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="teklik_satis" value={marjVal('teklik_satis')} onChange={handleChange} />{marjCheckbox('teklik')}</div>
      <div style={sectionRow}><h3 style={sectionH3}>Ata Lira</h3><MarjInput label="Alis" marjKey="ata_alis" value={marjVal('ata_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="ata_satis" value={marjVal('ata_satis')} onChange={handleChange} />{marjCheckbox('ata_lira')}</div>
      <div style={sectionRow}><h3 style={sectionH3}>Gremse</h3><MarjInput label="Alis" marjKey="gremse_alis" value={marjVal('gremse_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="gremse_satis" value={marjVal('gremse_satis')} onChange={handleChange} />{marjCheckbox('gremse')}</div>
      <div style={sectionRow}><h3 style={sectionH3}>Has Altin</h3><MarjInput label="Alis" marjKey="has_alis" value={marjVal('has_alis')} onChange={handleChange} /><MarjInput label="Satis" marjKey="has_satis" value={marjVal('has_satis')} onChange={handleChange} />{marjCheckbox('has_altin')}</div>
      {priceSource === 'altinkaynak' && (
        <div style={sectionRow}><h3 style={sectionH3}>Bilezik (TL)</h3><MarjInput label="Alis Marj" marjKey="bilezik_alis_marj" value={marjVal('bilezik_alis_marj')} onChange={handleChange} />{marjCheckbox('bilezik')}</div>
      )}
      {priceSource !== 'altinkaynak' && (
        <div style={sectionRow}><h3 style={sectionH3}>22 Ayar (Bilezik)</h3><MarjInput label="Carpan" marjKey="bilezik_carpan" value={marjVal('bilezik_carpan')} onChange={handleChange} /></div>
      )}
    </>
  );
};

export default OzanMarjInputs;
